(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coursesreviews"]) return;
  try {
    
  var tab=1;

  $('#testimonials nav a').on('click', function(e){
    e.preventDefault();
    tab = $(this).data('tab');

    $('#testimonials nav a').removeClass('active');
    $(this).addClass('active');

    $('#list .review').hide();
    $('#list .review.r'+tab).fadeIn();
  })

  $('#testimonials .arrownav .next').on('click', function(e){
    tab = tab+1;
    if(tab==4){
      tab = 1;
    }

    $('#testimonials nav a').removeClass('active');
    $('#testimonials nav a:nth-of-type('+tab+')').addClass('active');
    $('#list .review').hide();
    $('#list .review.r'+tab).fadeIn();
  })

  $('#testimonials .arrownav .prev').on('click', function(e){
    tab = tab-1;
    if(tab==0){
      tab = 3;
    }

    $('#testimonials nav a').removeClass('active');
    $('#testimonials nav a:nth-of-type('+tab+')').addClass('active');
    $('#list .review').hide();
    $('#list .review.r'+tab).fadeIn();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebookhero"]) return;
  try {
    
  /* slide not jump */
  $('#hero a').on('click', function(e){
    var href = $(this).attr("href");

    if(href.indexOf("#")>=0){
      hash = href.substr(href.indexOf("#"));
      if($(hash).length>0){
        e.preventDefault();
        var offset = $(hash).offset().top;

        $('html,body').animate({scrollTop: offset },'slow');
        
        document.location.hash = hash;
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebookinfo"]) return;
  try {
    
  /* slide not jump */
  $('#hero a').on('click', function(e){
    var href = $(this).attr("href");

    if(href.indexOf("#")>=0){
      hash = href.substr(href.indexOf("#"));
      if($(hash).length>0){
        e.preventDefault();
        var offset = $(hash).offset().top;

        $('html,body').animate({scrollTop: offset },'slow');
        
        document.location.hash = hash;
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeclasses"]) return;
  try {
    
var owlc = $('#classes .courses .owl-carousel').owlCarousel({
  'nav':true,
  'dots':false,
  'autoWidth':true,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homehero"]) return;
  try {
    
  /* slide not jump */
  $('#hero a').on('click', function(e){
    var href = $(this).attr("href");

    if(href.indexOf("#")>=0){
      hash = href.substr(href.indexOf("#"));
      if($(hash).length>0){
        e.preventDefault();
        var offset = $(hash).offset().top;

        $('html,body').animate({scrollTop: offset },'slow');
        
        document.location.hash = hash;
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeoffer"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('#offer nav ul li').on('click', function(){
      var tab = $(this).data('tab');

      $('#offer nav ul li').removeClass('active');
      $('#offer .tab').hide();

      $(this).addClass('active');
      $('#offer .tab.'+tab).fadeIn();
    })

    $('#offer nav ul li:nth-of-type(1)').addClass('active');
    $('#offer .tab.tab1').fadeIn();


    $(window).scroll(function(){
      var scrolled = $('html, body').scrollTop(),
      vpH = $(window).height(),
      Sstart = $('#offer .row:nth-of-type(1)').offset().top+100,
      Sstop = $('#reviews').offset().top-500;

      if(scrolled>Sstart && scrolled<Sstop){
        $('#offer').addClass('fixed');
        $('#offer').removeClass('fixedBottom');
      }
      else{
        $('#offer').removeClass('fixed');
        if(scrolled>Sstop){
          $('#offer').addClass('fixedBottom');
        }
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homereview"]) return;
  try {
    
  $('#reviews a.full').on('click', function(e){
    e.preventDefault();
    $(this).fadeOut();
    $('#reviews .text .more').slideDown();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcasthero"]) return;
  try {
    
  /* slide not jump */
  $('#hero a').on('click', function(e){
    var href = $(this).attr("href");

    if(href.indexOf("#")>=0){
      hash = href.substr(href.indexOf("#"));
      if($(hash).length>0){
        e.preventDefault();
        var offset = $(hash).offset().top - 50;

        $('html,body').animate({scrollTop: offset },'slow');
        
        document.location.hash = hash;
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privatequotes"]) return;
  try {
    
var owl = $('#quotes .owl-carousel').owlCarousel({
  'nav':false,
  'dots':true,
  'center':false,
  'items':1,
  'margin':50,
  'loop':true,
  'autoplay':true,
  'autoplayHoverPause':true,
  'autoplayTimeout':5000,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["publicquotes"]) return;
  try {
    
var owl = $('#quotes .owl-carousel').owlCarousel({
  'nav':false,
  'dots':true,
  'center':false,
  'items':1,
  'margin':50,
  'loop':true,
  'autoplay':true,
  'autoplayHoverPause':true,
  'autoplayTimeout':5000,
});

  } catch(e) { console.error(e); }
})();
})();
